import { render, staticRenderFns } from "./PayrollAccountsSection.vue?vue&type=template&id=3e95b0a5&scoped=true"
import script from "./PayrollAccountsSection.vue?vue&type=script&lang=js"
export * from "./PayrollAccountsSection.vue?vue&type=script&lang=js"
import style0 from "./PayrollAccountsSection.vue?vue&type=style&index=0&id=3e95b0a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95b0a5",
  null
  
)

export default component.exports